<template>
    <section v-if="hasType == 'date' || hasType == ''">
        <div class="form-group">
            <label :for="hasId" class="text-capitalize" v-html="hasReq" :class="{'none': this.nolabel === true}"></label>
            <div class=""
                :class="{
                    'cus-field': req === true,
                    danger: displayValue === '' && req === true,
                    success: displayValue !== '' && req === true,
                }"
            >
                <vue-datepicker
                    :id="hasId"
                    input-class="form-control"
                    type="date"
                    v-model="displayValue"
                    headerslot
                    format="DD/MM/YYYY"
                    :clearable="false"
                    :editable="true"
                    :placeholder="hasplaceholder"
                    value-type="YYYY-MM-DD"
                    :disabled="cDisable"
                >
                    <template v-slot:icon-calendar>
                        <svg :class="{'disabled': cDisable !== false}" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="#333333" class="bi bi-calendar" viewBox="0 0 16 16">
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </template>
                    <template v-slot:footer="{ emit }">
                        <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                    </template>
                </vue-datepicker>
            </div>
        </div>
    </section>
	<section v-else-if="hasType == 'time'">
        <div class="form-group">
            <label :for="hasId" class="text-capitalize" v-html="hasReq" :class="{'none': this.nolabel === true}"></label>
            <div class=""
                :class="{
                    'cus-field': req === true,
                    danger: displayValue === '' && req === true,
                    success: displayValue !== '' && req === true,
                }"
            >
                <vue-datepicker
                    :id="hasId"
                    input-class="form-control"
                    :placeholder="hasplaceholder"
                    v-model="displayValue"
                    :clearable="false"
                    headerslot
                    type="time"
                    format="HH:mm"
                    value-type="HH:mm"
                    :editable="true"
                    :disabled="cDisable"
                >
                    <template v-slot:icon-calendar>
                        <svg :class="{'disabled': cDisable !== false}" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="#333333" class="bi bi-clock" viewBox="0 0 16 16">
                            <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                        </svg>
                    </template>
                </vue-datepicker>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */
export default {
    props: ["title", "label", "placeholder", "value", "type", "req", "disable","nolabel" ],
    data() {
        return {
                option: {
                },
            }
    },
    computed: {
        hasType() {
            return (this.type === null || typeof this.type === 'undefined' || this.type === false) ? "" : this.type; //Date and time
        },
        hasplaceholder() {
            return (this.placeholder === null || typeof this.placeholder === 'undefined' || this.placeholder === false) ? "Select date" : this.placeholder;
        },
		hasReq() {
			if (this.label === null || typeof this.label === 'undefined') {
				return (this.hReq === false) ? this.title + ' : ' : this.title + ' : <span class="text-danger">*</span>';
			}else if(this.label === false){
				return '&emsp;'
			}else {
				return (this.hReq === false) ? this.label + ' : ' : this.label + ' : <span class="text-danger">*</span>';
			}
		},
        hReq() {
            return (this.req === null || typeof this.req === 'undefined' || this.req === false) ? false : true;
		},
		hasId() {
			return (this.title === null || typeof this.title === 'undefined') ? '' : this.title.split(' ').join('-');
		},
        cDisable() {
			return (this.disable === null || typeof this.disable === 'undefined') ? false : this.disable;
		},
        displayValue: {
            get () {
                if (this.value == '' || this.value === null || this.value === undefined || typeof this.value === 'undefined') {
					if (document.getElementById(this.hasId)) {
						document.getElementById(this.hasId).value = ''
					}
					return '';
				}else{
					return (this.type == 'time')? this.value+":00":this.value;
				}
            },
            set (modifiedValue) {
                if (modifiedValue == '' || modifiedValue === null || modifiedValue === undefined || typeof modifiedValue === 'undefined') {
					if (document.getElementById(this.hasId)) {
						document.getElementById(this.hasId).value = ''
                        this.$emit('input', '')
					}
				}else{
                    this.$emit('input', (this.type == 'time')? modifiedValue+":00":modifiedValue)
                }
            }
        }
    },
    methods: {
		updateing () {
			this.$emit('input', this.mdata);
		}
	}
};
</script>

<style scoped>
    label.none{
        display: none;
    }
    *>>>.mx-datepicker{
        width: 100%;
    }
    *>>>.mx-datepicker svg{
        width: 1.5em;
        height: 1.5em;
        color: #2d353c;
    }
    *>>>input.form-control::-webkit-input-placeholder{
        color: #2d353c !important;
    }
    svg.disabled{
		display: none;
	}
</style>
